'use client';
import { Typography } from 'components';
import { ColorsStatus } from 'constants/status';
import { motion } from 'framer-motion';
import Link from 'next/link';
import { FC, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import { cn } from 'utils/cn';
import './styles.scss';

interface IBadge {
  icon?: JSX.Element;
  transparent?: boolean;
  color?: ColorsStatus;
  href?: string;
  endAdornment?: ReactNode;
  target?: string;
  className?: string;
  classNameTypography?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLDivElement>;
}

const Badge: FC<PropsWithChildren<IBadge>> = ({
  children = '',
  icon,
  color = 'cyan',
  transparent,
  href = '#',
  target = '',
  className = '',
  classNameTypography = '',
  endAdornment,
  onClick
}) => {
  const ComponentButton: FC<{ onClick?: MouseEventHandler<HTMLDivElement> }> = ({ onClick }) => (
    <motion.div
      whileTap={href === '#' ? {} : { scale: 0.95 }}
      transition={
        href === '#'
          ? {}
          : {
              type: 'spring',
              stiffness: 300,
              damping: 25,
              restDelta: 10,
              mass: 1
            }
      }
      className={cn(
        'flex h-7 w-max flex-row items-center gap-2 rounded-10xl pl-1 pr-2 outline-none',
        `badge--${color}`,
        className
      )}
      onClick={onClick}
    >
      {icon && <>{icon}</>}
      {children && (
        <Typography
          className={cn('!w-fit select-none text-white', classNameTypography)}
          variant={transparent ? 'medium4' : 'regular4'}
        >
          {children}
        </Typography>
      )}
      {endAdornment && <>{endAdornment}</>}
    </motion.div>
  );

  if (href === '#')
    return (
      <div className="tolq-badge">
        <ComponentButton onClick={onClick} />
      </div>
    );

  return (
    <Link
      className={cn(
        'tolq-badge',
        transparent ? 'tolq-badge-transparent' : '',
        href !== '#' ? 'cursor-pointer' : 'cursor-default'
      )}
      href={href}
      target={target}
      onClick={onClick}
    >
      <ComponentButton />
    </Link>
  );
};
export default Badge;
